import createLucideIcon from '../createLucideIcon';

const Option = createLucideIcon('Option', [
  ['path', { d: 'M3 3h6l6 18h6', key: 'ph9rgk' }],
  ['path', { d: 'M14 3h7', key: '16f0ms' }],
]);

export default Option;
